import Button from '@carvana/ds-button';
import { icon } from '@carvana/ds-styles';
import { CircleAlert } from 'lucide-react';
import React from 'react';
import { EventedModal, ModalNames } from '|/app/modals';
import useUnavailableVm from './unavailable-modal-vm';
import styles from '../../gap-coverage.module.css';

interface UnavailableModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const UnavailableModal: React.FC<UnavailableModalProps> = ({ isOpen, onClose }) => {
  const { handleCloseModal } = useUnavailableVm({ onClose });

  return (
    <EventedModal
      isOpen={isOpen}
      analyticsId={ModalNames.GapCoverageUnavailable}
      aria-label="GAP coverage removed"
      mobileStyle="inset"
      divLine={false}
      onClose={handleCloseModal}
      disableOutsideClose={true}
      disableEscapeClose={true}
      closeIcon={false}
      desktopWidth="480px"
    >
      <div className={styles.contentLockup}>
        <div className={styles.modalContent}>
          <div className={styles.modalHeading}>
            <div className={styles.modalIcon} data-testid="qe-gap-unavailable-modal-icon">
              <CircleAlert color={icon.warning} />
            </div>
            <div className={styles.modalTitle}>GAP coverage removed</div>
          </div>
          <div className={styles.modalText}>
            Based on your current selection, you no longer meet the requirements for GAP coverage.
            We&apos;ve removed it from your order and updated your financing terms. Please review
            your terms to proceed.
          </div>
        </div>
        <Button onClick={handleCloseModal} data-analytics-id="gap-removed-continue" width="100%">
          Continue
        </Button>
      </div>
    </EventedModal>
  );
};

export default UnavailableModal;
